import { Span } from "./styles";

const TextSpan = ({ fontWeight, children }) => {
  return <Span fontWeight={fontWeight}>{children}</Span>;
};

export default TextSpan;
